(function () {
  'use strict';

  var SCRIPT_URL = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
  var scriptPromise;

  function statusMessage(message) {
    var status = document.querySelector('[data-consent-status]');
    if (status) status.textContent = message;
  }

  function loadPrivacyBanner() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      return Promise.resolve(window.privacyBanner);
    }
    if (scriptPromise) return scriptPromise;

    scriptPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + SCRIPT_URL + '"]');
      var script = existing || document.createElement('script');

      function ready() {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          resolve(window.privacyBanner);
        } else {
          reject(new Error('Shopify privacy preferences are unavailable'));
        }
      }

      if (existing) {
        if (window.privacyBanner) ready();
        else {
          existing.addEventListener('load', ready, { once: true });
          existing.addEventListener('error', reject, { once: true });
        }
        return;
      }

      script.src = SCRIPT_URL;
      script.async = true;
      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
    return scriptPromise;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-consent-summon]');
    if (!trigger) return;

    statusMessage('Opening cookie preferences.');
    loadPrivacyBanner()
      .then(function (banner) { return banner.showPreferences(); })
      .then(function () { statusMessage('Cookie preferences opened.'); })
      .catch(function () {
        scriptPromise = null;
        statusMessage('Cookie preferences are temporarily unavailable. Please review the privacy policy.');
      });
  });
})();
